import { IRoleEnum } from "@interfaces";
import { createRoute } from "@routes/utils";

import { supplierBasedSalesReportRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";

const permission = [IRoleEnum.STORE_EMPLOYEE];

const supplierBasedSalesReportRouteMetadata: IRouteMetadataObj<
  typeof supplierBasedSalesReportRoutesObj
> = {
  list: {
    title: "seller.salesReport.index.title",
    description: "empty",
    lazy: () => import("@pages/reportManagement/supplierBasedSalesReport/page"),
    mode: "index",
    type: "main",
    icon: "FileChartLine",
    breadcrumbs: [],
    permission,
  },
};

export const supplierBasedSalesReportRoutes = createRoute<
  typeof supplierBasedSalesReportRoutesObj
>(supplierBasedSalesReportRoutesObj, supplierBasedSalesReportRouteMetadata);
